import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import {
  getSubscriptionColorBgClass,
  type SubscriptionColorName,
} from '../../../../utils/client-booking-subscription-color.util';

export interface ClientBookingSubscriptionTypeRow {
  TypeName: string;
  SubscriptionColor?: SubscriptionColorName | '';
}

@Component({
  selector: 'client-booking-subscription-type-cell',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, NgClass],
  template: `
    @if ({ row: columnData | async }; as $) {
      @if ($.row) {
        <div class="flex align-items-center gap-2">
          @if ($.row.SubscriptionColor) {
            <span
              [ngClass]="colorClass($.row.SubscriptionColor)"
              class="inline-block h-1rem w-1rem border-circle flex-shrink-0"
              aria-hidden="true"
              data-testid="subscription-color-indicator"
            ></span>
          }
          <span>{{ $.row.TypeName }}</span>
        </div>
      }
    }
  `,
})
export class ClientBookingSubscriptionTypeCellComponent {
  columnData: Observable<ClientBookingSubscriptionTypeRow | null> =
    new BehaviorSubject<ClientBookingSubscriptionTypeRow | null>(null);

  colorClass(color: SubscriptionColorName | ''): string {
    return getSubscriptionColorBgClass(color || null);
  }
}
